import React, { useEffect, useState, useRef } from 'react'
import LoadingPaul from '../LoadingPaul'

export default function RedirectTotvs() {
    const [user, setUser] = useState(null);
    const [origemParamRedirect, setOrigemParamRedirect] = useState(null);
    const [alias, setAlias] = useState(null);
    const [password, setPassword] = useState(null);

    const formRef = useRef(null);

    useEffect(() => {
        const totvsRegistration = localStorage.getItem('totvsRegistration') ? JSON.parse(localStorage.getItem('totvsRegistration')) : null;
        if(totvsRegistration) {
          setUser(totvsRegistration.registration);
          setOrigemParamRedirect(process.env.REACT_APP_TOTVS_URL_REDIRECT);
          setAlias(process.env.REACT_APP_TOTVS_ALIAS);
          setPassword(process.env.REACT_APP_TOTVS_PASSWORD);
        }
    }, []);

    useEffect(() => {
      if (origemParamRedirect && user && alias && password) {
        formRef.current.submit();
      }
    }, [origemParamRedirect, user, alias, password])

    return (
      <>
        {origemParamRedirect && user && alias && password && (
          <form ref={formRef} action={origemParamRedirect} method="post" className="hide">
            <input type="hidden" name="user"value={user} className="hide" />
            <input type="hidden" name="alias" value={alias} className="hide" />
            <input type="hidden" name="pass" value={password} className="hide" />
            <input id="commit" type="submit" value="ACESSAR" style={{ display: "none" }} />
          </form>
        )}
        <div style={{ margin: '0 auto' }}>
          <LoadingPaul message="Aguarde, estamos redirecionando você para o Portal do Aluno..." />
        </div>  
      </>
    )
}
